import { Component, OnInit } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { AppStateService } from '../services/app-state.service';
import { HomeService } from "../services/home.service";
import { ActionType } from "../models/entity-action.model";
import { TableConfiguration } from "../models/table-configuration.model";
import { StatusInfo } from "../models/status-info.model";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  // props
  public info: StatusInfo;
  public actions: ActionType[] = [];

  public config: TableConfiguration;

  public loading: boolean = false;

  public get collectionTitle(): string {
    return this.info?.collections?.title ?? 'My Data Collections'
  }

  public get requestTitle(): string {
    return this.info?.requests?.title ?? 'My Data Utilization Requests'
  }

  public get uploadTitle(): string {
    return this.info?.uploads?.title ?? 'My Data Uploads'
  }

  // ctor
  constructor(public homeService: HomeService,
    private appStateService: AppStateService) { }

  // methods
  ngOnInit() {
    this.appStateService.initPage();

    // load status info
    this.loading = true;
    this.homeService.getStatusInfo().pipe(
      finalize(() => this.loading = false)
    ).subscribe(response => {
      this.info = response.value;
      this.actions = response.actions;
    });

    // load table config
    this.homeService.getConfiguration()
      .subscribe(response => this.config = response.value);
  }

  public canCreateCollection(): boolean {
    return !this.loading && this.actions.some(a => a === ActionType.CreateCollection);
  }

  public canCreateRequest(): boolean {
    return !this.loading && this.actions.some(a => a === ActionType.CreateRequest);
  }

  public canCreateUpload(): boolean {
    return !this.loading && this.actions.some(a => a === ActionType.CreateUpload);
  }

  public getTitleFirstPart(title: string): string {
    const parts = title.split(' ');
    return parts.length > 1 ? `${parts.slice(0, parts.length - 1).join(' ')} ` : '';
  }

  public getTitleSecondPart(title: string): string {
    const parts = title.split(' ');
    return parts.length > 1 ? parts[parts.length - 1] : title;
  }
}
